'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import H5 from 'UIComponents/elements/headings/H5';
import { GYPSUM, FLINT } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { GUARANTEE_SECTION } from 'pricing-pages-unified-ui/constants/Breakpoints';
import GuaranteeBlob from './GuaranteeBlob';
import SignupButton from 'pricing-pages-unified-ui/components/public-only/SignupButton';
import EnvironmentWrapper from 'pricing-pages-unified-ui/components/EnvironmentWrapper';
import breakpoint from '../../utils/responsiveBreakpoints';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../loading/SkeletonLoadWrapper';
const Guarantee = styled(({
  className,
  icon,
  header,
  body
}) => /*#__PURE__*/_jsxs("div", {
  className: className,
  children: [/*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: icon,
      color: FLINT,
      size: "medium",
      className: "m-bottom-2"
    })
  }), /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(H5, {
      children: header
    })
  }), /*#__PURE__*/_jsx("div", {
    children: body
  })]
})).withConfig({
  displayName: "GuaranteeSection__Guarantee",
  componentId: "sc-1ehv8qc-0"
})(["width:240px;text-align:center;@media (max-width:", "px){&:not(:last-child){margin-bottom:10px;}}"], GUARANTEE_SECTION);
const GuaranteeRow = styled.div.withConfig({
  displayName: "GuaranteeSection__GuaranteeRow",
  componentId: "sc-1ehv8qc-1"
})(["display:flex;justify-content:space-between;flex-wrap:nowrap;margin-bottom:24px;width:100%;max-width:870px;@media (max-width:", "px){flex-direction:column;align-items:center;}"], GUARANTEE_SECTION);
const GuaranteeSection = styled(({
  className
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(GuaranteeBlob, {}), /*#__PURE__*/_jsx(H1, {
      className: "m-bottom-12 text-center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crm.guarantee"
      })
    }), /*#__PURE__*/_jsxs(GuaranteeRow, {
      children: [/*#__PURE__*/_jsx(Guarantee, {
        icon: "lists",
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.unlimitedHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.unlimitedBody"
        })
      }), /*#__PURE__*/_jsx(Guarantee, {
        icon: "tag",
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeBody"
        })
      }), /*#__PURE__*/_jsx(Guarantee, {
        icon: "generateChart",
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.dataHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.dataBody"
        })
      })]
    }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
      authedNode: /*#__PURE__*/_jsx("span", {
        className: "p-y-5 m-top-5"
      }),
      publicNode: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        widths: [200],
        heights: [56],
        children: /*#__PURE__*/_jsx(SignupButton, {
          sourceId: "pricing-middle",
          productLine: "crm",
          className: "p-x-9 p-y-5 m-top-5",
          ctaKey: "pricingPage.signupCtas.getStartedFree"
        })
      })
    })]
  });
}).withConfig({
  displayName: "GuaranteeSection",
  componentId: "sc-1ehv8qc-2"
})(["display:flex;text-align:center;flex-direction:column;align-items:center;margin-top:80px;margin-bottom:30px;padding:40px 16px;width:100%;position:relative;z-index:1;@media (max-width:", "px){background-color:", ";margin-top:40px;margin-bottom:0;padding-bottom:2.1em;}", ";"], GUARANTEE_SECTION, GYPSUM, breakpoint.tablet(_t || (_t = _`
    height: auto;
  `)));
export default GuaranteeSection;